import React from 'react';
import appPath from '../lib/appPath';
import {routeToLogin} from '../lib/utils';
import {useAuth} from 'react-oidc-context';
import {Redirect} from 'react-router-dom';

const CallbackPage = () => {
  const auth = useAuth();

  if (auth.isLoading) {
    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
        <p>Signing in...</p>
      </div>
    );
  }

  if (auth.error) {
    // A failed code exchange leaves half-written OIDC state behind. Send the
    // user to /login via routeToLogin (which clears that state first) so the
    // retry starts clean instead of resuming the broken flow.
    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', gap: 16}}>
        <p>Authentication error: {auth.error.message}</p>
        <button onClick={routeToLogin}>Back to login</button>
      </div>
    );
  }

  if (auth.isAuthenticated) {
    // Hard reload (NOT <Redirect>) so every module re-reads from the freshly
    // stored user instead of running with closure-captured tokens or
    // Redux state from a prior session. Fixes the stale-token failure
    // pattern documented in src/auth/auth_state_lifecycle.md.
    window.location.replace(appPath('/dashboard'));
    return null;
  }

  return <Redirect to="/" />;
};

export default CallbackPage;
